export default "__VITE_ASSET__BHz_bY6t__"